// Staggered entrance for [data-vd-reveal] parts. Content stays visible when this script never runs.
(() => {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -10% 0px' }
  );

  const watch = (root) => {
    for (const el of root.querySelectorAll('[data-vd-reveal]:not(.is-in)')) {
      // Whatever is already on screen stays put; only later parts enter.
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in');
      else observer.observe(el);
    }
  };

  document.documentElement.classList.add('vd-reveal-ready');
  watch(document);
  document.addEventListener('shopify:section:load', (event) => watch(event.target));
})();
